import { useStyle } from "../style";
import { SvgIcon } from "@mui/material";
import viewIconImg from "@static/img/bills/view.svg";

export const ViewIcon = () => {
    const { classes } = useStyle({});

    return <SvgIcon className={classes.iconBox} component={viewIconImg} viewBox="0 0 36 36" />;
};
